import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { EntityWithUuid, NkCardListItemAbstractComponent } from '../card-list.utils';

/*
 * Renders the value via [innerHTML]. Only for trusted, app-built markup —
 * any user-controlled data must be escaped by the caller (escapeHtml).
 * For plain text use CardListItemTextComponent.
 */
@Component({
  selector: 'nk-card-list-item-html',
  imports: [],
  templateUrl: './card-list-item-html.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListItemHtmlComponent<Entity extends EntityWithUuid> extends NkCardListItemAbstractComponent<Entity> {
  public html = computed(() => {
    const value = this.valueSignal();
    if (!value) {
      return null;
    }
    return value.entity[value.prop];
  });
}
